import styled from 'styled-components'
import { Card as YogaCard } from '@gympass/yoga'
import tokens from '@gympass/yoga-tokens'

import Image from '@components/Image'

export const Card = styled(YogaCard)`
  padding: 40px 40px 32px;
  position: sticky;
  margin: 80px auto 10px 48px;
  width: 432px;
  top: 40px;
  box-sizing: border-box;
`

export const CardHeader = styled(YogaCard.Header)`
  margin-bottom: 24px;
`

export const CardTitle = styled.h6`
  font-style: normal;
  font-weight: 500;
  margin: 0;
  font-size: 24px;
  line-height: 29px;
`

export const CardContent = styled(YogaCard.Content)`
  margin-bottom: 40px;
`

export const PriceRow = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`

export const PriceDescription = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  margin: 0;
  color: ${tokens.colors.deep};

  span {
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
  }
`

export const PriceValue = styled.p`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  text-align: right;
  margin: 0;

  em {
    text-decoration-line: line-through;
    font-style: normal;
  }
`

export const Divider = styled.hr`
  margin-top: 24px;
  margin-bottom: 16px;
  border: 1px solid rgba(0, 0, 0, 0.15);
`

export const TotalWrapper = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #001027;

  span {
    margin-left: 2px;
    font-size: 24px;
    font-weight: 500;
  }
`

export const CardFooter = styled.section`
  display: flex;
  justify-content: space-between;
`

export const CardFooterText = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  width: 340px;
  margin: 0;
`

export const CardFooterIllustration = styled(Image)`
  height: 168px;
  position: absolute;
  right: 40px;
  margin-top: 120px;
`

export const StrippedValue = styled.s`
  padding-right: 5px;
  color: var(--secondary-text);
`

export const FreeValue = styled.span`
  color: ${tokens.colors.vibin};
`
export const DisclaimerWrapper = styled.section`
  font-size: 10px;
  position: absolute;
  line-height: 12px;
  margin-bottom: 40px;
  max-width: 432px;
  margin-top: 35px;
`
